import React, { useEffect, useState, useContext } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { IsAuthorizedContext } from '../../../contexts/isAuthorizedContext';
import { confirmEmail } from '../services/AuthCRUD';
import useAxiosPrivate from '../../../contexts/CustomContextHook/useAxiosPrivate';



const ConfirmEmail = () => {

    console.log('in Confirm Email Component ----------');



    // const { token, userId } = useParams<{ token?: string, userId?: string }>();

    // console.log('userId Component-------', userId);



    let query = new URLSearchParams(useLocation().search);


    const Token = query.get("token")
    const userId = query.get("userId")


    console.log('UserID === ', userId);

    console.log('Token ---- ', Token);


    const history = useHistory();

    const [loading, setLoading] = useState(false)
    const [Errors, setErrors] = useState('')


    const isAuthorizedCxt = useContext(IsAuthorizedContext);

    const axiosPrivate = useAxiosPrivate()

    useEffect(
        () => {

            console.log('userId in useEffect', userId);

            setLoading(true);

            confirmEmail(axiosPrivate, { userId, Token })
                .then(
                    () => {

                        setLoading(false);
                        setErrors('');


                        // alert('Email Confirmed');
                    }
                ).catch(
                    (error : any) => {
                        console.log(error);
                        setLoading(false);
                        setErrors(error);
                        // alert('Error in Confirming Email ');

                    }
                )

        }, []
    )





    return (
        <div className="row">
            {/* offset-md-3 */}
            <div className="col-md-12 mt-4">
                <h3 className="mb-5">Email Confirmation Page</h3>
                {Errors == '' && !loading &&
                    <div className="alert alert-primary" role="alert">
                        Email confirmed
                    </div>
                }
                {Errors &&
                    <div className="alert alert-warning" role="alert">
                        Unable to confirm email
                    </div>
                }
            </div>
            {Errors == '' && !loading &&
                <button
                    type='button'
                    className='btn btn-lg btn-light-primary w-100 mb-5'
                    onClick={() => {
                        localStorage.setItem('isAuthorized', 'true');
                        isAuthorizedCxt.setIsaAuthorized(true);

                        history.push('/dashboard')
            
                    }
                    }>
                    Go to Home Page
                </button>
            }

        </div>
    )
}

export default ConfirmEmail
